// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ion-tags-input {
  border-bottom: 1px solid #e5e5e5;
  transition: border-bottom-color 0.15s ease;
  padding: 5px;
  display: block;
}
.ion-tags-input .iti-tag-color {
  background-color: var(--ion-color-primary);
  color: #727272;
}
.ion-tags-input.active {
  border-bottom-color: var(--ion-color-primary);
}
.ion-tags-input .iti-tag {
  display: block;
  float: left;
  font-family: sans-serif;
  font-size: 14px;
  font-weight: 400;
  margin-right: 5px;
  margin-bottom: 5px;
  padding: 4px 10px;
  max-height: 40px;
  border-radius: 0;
}
.ion-tags-input .iti-tag.iti-tag-ios {
  border-radius: 13px;
}
.ion-tags-input .iti-tag.iti-tag-md {
  border-radius: 4px;
}
.ion-tags-input .iti-tag.iti-tag-web {
  float: right !important;
}
.ion-tags-input .iti-tag.ion-color {
  color: var(--ion-color-contrast);
  background-color: var(--ion-color-base);
}
.ion-tags-input .iti-tag-cmp {
  display: block;
  float: right;
  font-family: sans-serif;
  font-size: 14px;
  font-weight: 400;
  margin-right: 5px;
  margin-bottom: 5px;
  padding: 4px 10px;
  max-height: 40px;
  border-radius: 0;
}
.ion-tags-input .iti-tag-cmp.iti-tag-ios {
  border-radius: 13px;
}
.ion-tags-input .iti-tag-cmp.iti-tag-md {
  border-radius: 4px;
}
.ion-tags-input .iti-tag-cmp.iti-tag-web {
  float: right !important;
}
.ion-tags-input .iti-tag-cmp.ion-color {
  color: var(--ion-color-contrast);
  background-color: var(--ion-color-base);
}
.ion-tags-input .iti-input {
  background: transparent;
  border: 0;
  color: #777;
  font-family: sans-serif;
  font-size: 13px;
  font-weight: 400;
  outline: none;
  padding: 5px;
}
.ion-tags-input a.iti-tag-rm::before {
  content: "  X";
  cursor: pointer;
  color: #727272;
}
.ion-tags-input.tit-border-color.readonly, .ion-tags-input.active.tit-border-color.readonly {
  border: none;
}
.ion-tags-input .iti-input-cmp {
  background: transparent;
  border: 0;
  color: #999;
  font-family: sans-serif;
  font-size: 14px;
  font-weight: 400;
  outline: none;
  padding: 5px 5px 5px 0px;
  width: 100%;
  text-align: right;
}
.ion-tags-input .iti-input-cmp::placeholder {
  opacity: 0.5 !important;
}
.ion-tags-input .tranfrom_txt {
  text-transform: lowercase;
}`, "",{"version":3,"sources":["webpack://./src/app/core/components/ion-tags-input/ion-tags-input.scss"],"names":[],"mappings":"AAAA;EAQE,gCAAA;EACA,0CAAA;EACA,YAAA;EACA,cAAA;AANF;AAFE;EACE,0CAHc;EAId,cAAA;AAIJ;AAIE;EACE,6CAbc;AAWlB;AAKE;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAHJ;AAKI;EACE,mBAAA;AAHN;AAMI;EACE,kBAAA;AAJN;AAMI;EACE,uBAAA;AAJN;AAMI;EACE,gCAAA;EACA,uCAAA;AAJN;AAOA;EACE,cAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AALF;AAOE;EACE,mBAAA;AALJ;AAQE;EACE,kBAAA;AANJ;AAQE;EACE,uBAAA;AANJ;AAQE;EACE,gCAAA;EACA,uCAAA;AANJ;AASE;EACE,uBAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;AAPJ;AAUE;EACE,cAAA;EACA,eAAA;EACA,cAAA;AARJ;AAWE;EAEE,YAAA;AAVJ;AAYE;EACE,uBAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,wBAAA;EACA,WAAA;EACA,iBAAA;AAVJ;AAYE;EACE,uBAAA;AAVJ;AAYE;EACE,yBAAA;AAVJ","sourcesContent":[".ion-tags-input {\n  $default-color: var(--ion-color-primary);\n\n  .iti-tag-color {\n    background-color: $default-color;\n    color: #727272;\n  }\n\n  border-bottom: 1px solid #e5e5e5;\n  transition: border-bottom-color 0.15s ease;\n  padding: 5px;\n  display: block;\n\n  &.active {\n    border-bottom-color: $default-color;\n  }\n\n  .iti-tag {\n    display: block;\n    float: left;\n    font-family: sans-serif;\n    font-size: 14px;\n    font-weight: 400;\n    margin-right: 5px;\n    margin-bottom: 5px;\n    padding: 4px 10px;\n    max-height: 40px;\n    border-radius: 0;\n\n    &.iti-tag-ios {\n      border-radius: 13px;\n    }\n\n    &.iti-tag-md {\n      border-radius: 4px;\n    }\n    &.iti-tag-web {\n      float: right !important;\n    }\n    &.ion-color {\n      color: var(--ion-color-contrast);\n      background-color: var(--ion-color-base);\n    }\n  }\n.iti-tag-cmp{\n  display: block;\n  float: right;\n  font-family: sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  margin-right: 5px;\n  margin-bottom: 5px;\n  padding: 4px 10px;\n  max-height: 40px;\n  border-radius: 0;\n\n  &.iti-tag-ios {\n    border-radius: 13px;\n  }\n\n  &.iti-tag-md {\n    border-radius: 4px;\n  }\n  &.iti-tag-web {\n    float: right !important;\n  }\n  &.ion-color {\n    color: var(--ion-color-contrast);\n    background-color: var(--ion-color-base);\n  }\n}\n  .iti-input {\n    background: transparent;\n    border: 0;\n    color: #777;\n    font-family: sans-serif;\n    font-size: 13px;\n    font-weight: 400;\n    outline: none;\n    padding: 5px;\n  }\n\n  a.iti-tag-rm::before {\n    content: \"  X\";\n    cursor: pointer;\n    color: #727272;\n  }\n\n  &.tit-border-color.readonly,\n  &.active.tit-border-color.readonly {\n    border: none;\n  }\n  .iti-input-cmp {\n    background: transparent;\n    border: 0;\n    color: #999;\n    font-family: sans-serif;\n    font-size: 14px;\n    font-weight: 400;\n    outline: none;\n    padding: 5px 5px 5px 0px;\n    width:100%;\n    text-align: right;\n  }\n  .iti-input-cmp::placeholder {\n    opacity:0.5 !important;\n  }\n  .tranfrom_txt{\n    text-transform: lowercase;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
